module.exports = __webpack_public_path__ + "img/logo_griffin.768f5745.svg";